import { faAt, faEnvelopeOpen, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { ColumnDescription } from "react-bootstrap-table-next";
import ExportExcel from "../../../../../Components/StickyToolbar/ExportExcel";
import Table from "../../../../../Components/Table";
import {
    ExportarExcelRelatorioDeEnvioReguaController,
    ListarRelatorioDeEnvioReguaController,
} from "../../../../../Controllers/Automacao/Regua/RelatorioEnvioRegua/RelatorioEnvioReguaControllers";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../../../hooks/usePaginationFilter";
import {
    IRelatorioReguaRequest,
    ListaRelatorio,
} from "../../../../../Interfaces/Automacao/Regua/RelatorioDeEnvioRegua/RelatorioDeEnvioReguaInterfaces";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ModalComponent from "../../../../../Components/Modais";
import { IComponentModal } from "../../../../../Components/Modais/IModalComponent";
import { useState } from "react";
import VisualizarRelatorioModal from "../VisualizarRelatorioModal";

interface IRelatorioReguaProps {
    req: IRelatorioReguaRequest;
}

export default function RelatorioRegua(props: IRelatorioReguaProps) {
    const { PageFilter, setPage } = usePaginationFilter({ page: 1 });
    const [modal, setModal] = useState<IComponentModal>();
    const [show, setShow] = useState(false);

    const { value: lstRelatorioRegua, loading: lstRelatorioReguaLoading } =
        useAsyncEffect(async () => {
            return ListarRelatorioDeEnvioReguaController(
                props.req,
                PageFilter.page
            );
        }, [props.req, PageFilter.page]);

    const totalPaginas = lstRelatorioRegua?.NR_PAGINA || 1;

    const columns: Array<ColumnDescription> = [
        {
            dataField: "ID_CASO_COBRANCA_REGUA_HISTORICO_ENVIO",
            text: "Acompanhamento de Réguas",
            formatter: (_c, row) => <RowFormatter {...row} />,
        },
    ];

    function RowFormatter(row: ListaRelatorio) {
        return (
            <div className="card p-2 m-2">
                <div className="d-flex flex-column align-items-center p-3">
                    {
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="remover-tooltip">
                                    Visualizar Relatório
                                </Tooltip>
                            }
                        >
                            <button
                                className="btn btn-outline-primary"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        Component: () =>
                                            VisualizarRelatorioModal({
                                                setShow,
                                                row,
                                            }),
                                        size: "lg",
                                        headerComponent:
                                            "Conteúdo do Relatório",
                                        IconHeader: faEnvelopeOpen,
                                        noFooter: true,
                                    });
                                }}
                            >
                                Visualizar Relatório
                            </button>
                        </OverlayTrigger>
                    }
                </div>
                <div className="d-flex flex-wrap align-items-center justify-content-between">
                    <h3 className="font-weight-bolder font-size-normal">
                        <span className="text-dark-75">{row.DS_NOME_ACAO}</span>
                    </h3>
                    <div className="d-flex flex-wrap align-items-start">
                        <span className="label label-light-primary label-inline mr-2 my-1">
                            Aging {row.NR_AGING_DIAS_CONTRATo} Dias
                        </span>
                        {row.DS_EMAIL && (
                            <span className="label label-light-primary label-inline mr-2 my-1">
                                <FontAwesomeIcon icon={faAt} className="mr-1" />{" "}
                                {row.DS_EMAIL}
                            </span>
                        )}
                        <span className="d-flex flex-wrap align-items-center justify-content-between">
                            <span className="d-flex flex-wrap flex-column mr-1 align-items-center">
                                <span className="d-block font-weight-bold">
                                    Data de Envio
                                </span>
                                <span className="label label-light-primary label-inline my-1">
                                    {moment(row.DT_ENVIO).format("ll")}
                                </span>
                            </span>
                        </span>
                    </div>
                </div>

                <div className="d-flex flex-wrap justify-content-evenly g-2">
                    <div className="d-flex flex-column align-items-center p-3">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Régua
                        </span>
                        <span className="text-dark flex-root font-weight-bold text-center">
                            {row.DS_NOME_REGUA}
                        </span>
                    </div>
                    <div className="d-flex flex-column align-items-center p-3">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Etapa
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {row.DS_NOME_ETAPA}
                        </span>
                    </div>
                    <div className="d-flex flex-column align-items-center p-3">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Tipo de Ação
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {row.DS_TIPO_ACAO}
                        </span>
                    </div>
                    <div className="d-flex flex-column align-items-center p-3">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Cliente
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {row.DS_CLIENTE}
                        </span>
                    </div>
                    <div className="d-flex flex-column align-items-center p-3">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Produto
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {row.DS_PRODUTO.split("-")[0]} -{" "}
                            {row.DS_IDENTIFICADOR}
                        </span>
                    </div>
                    <div className="d-flex flex-column align-items-center p-3">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Contrato
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {row.DS_CLASSIFICACAO_CONTRATO}
                        </span>
                    </div>
                    <div className="d-flex flex-column align-items-center p-3">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Chave ERP
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {row.ID_CHAVE_ERP}
                        </span>
                    </div>
                </div>
            </div>
        );
    }

    const tableViewColumns: Array<ColumnDescription<ListaRelatorio>> = [
        {
            dataField: "",
            text: "",
            isDummyField: true,
            formatter: (_, row) => (
                <div className="d-flex d-flex flex-row-reverse g-2 p-2">
                    <div>
                        {
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="remover-tooltip">
                                        Visualizar Relatório
                                    </Tooltip>
                                }
                            >
                                <button
                                    className="btn btn-icon btn-outline-primary"
                                    onClick={() => {
                                        setShow(true);
                                        setModal({
                                            Component: () =>
                                                VisualizarRelatorioModal({
                                                    setShow,
                                                    row,
                                                }),
                                            size: "lg",
                                            headerComponent:
                                                "Conteúdo do Relatório",
                                            IconHeader: faEnvelopeOpen,
                                            noFooter: true,
                                        });
                                    }}
                                >
                                    <FontAwesomeIcon icon={faEye} size="lg" />
                                </button>
                            </OverlayTrigger>
                        }
                    </div>
                </div>
            ),
        },
        {
            dataField: "DS_NOME_REGUA",
            text: "Régua de Cobrança",
            classes: "p-3 ws-nowrap",
            sort: true,
        },
        {
            dataField: "DS_NOME_ETAPA",
            text: "Etapa da Régua",
            classes: "p-3 ws-nowrap",
            sort: true,
        },
        {
            dataField: "DS_TIPO_ACAO",
            text: "Tipo de Ação",
            classes: "p-3 ws-nowrap",
            sort: true,
        },
        {
            dataField: "DS_NOME_ACAO",
            text: "Nome da Ação",
            classes: "p-3 ws-nowrap",
            sort: true,
        },
        {
            dataField: "DS_CLIENTE",
            text: "Cliente",
            classes: "p-3 ws-nowrap",
            sort: true,
        },
        {
            dataField: "DS_EMAIL",
            text: "E-mail",
            classes: "p-3 ws-nowrap",
            sort: true,
        },
        {
            dataField: "DS_PRODUTO",
            text: "Produto",
            classes: "p-3 ws-nowrap",
            sort: true,
            formatter: (c: string) => {
                const split = c.split("-");
                return `${split[0]} - ${split[2]}`;
            },
        },
        {
            dataField: "DS_CLASSIFICACAO_CONTRATO",
            text: "Classificação do Contrato",
            classes: "p-3 ws-nowrap",
            sort: true,
        },
        {
            dataField: "NR_AGING_DIAS_CONTRATo",
            text: "Aging Dias",
            classes: "p-3 ws-nowrap",
            sort: true,
        },
        {
            dataField: "DT_ENVIO",
            text: "Data de envio",
            formatter: (c) => moment(c).format("DD/MM/YY HH:mm"),
            classes: "p-3 ws-nowrap",
            sort: true,
        },
        {
            dataField: "ID_CHAVE_ERP",
            text: "Chave ERP",
            classes: "p-3 ws-nowrap",
            sort: true,
        },
    ];
    return (
        <div>
            <Table
                data={lstRelatorioRegua?.lstRelatorio ?? []}
                keyField="ID_CASO_COBRANCA_REGUA_HISTORICO_ENVIO"
                loading={lstRelatorioReguaLoading}
                noDataIndication={
                    <div className="text-muted text-center">
                        Nenhum resultado
                    </div>
                }
                onTableChange={(type, newState) => {
                    setPage(newState.page);
                }}
                remote={{ pagination: true }}
                totalPages={totalPaginas}
                tableView={{
                    columns: tableViewColumns,
                    sizePerPage: 20,
                    cancelYScroll: true,
                }}
                sizePerPage={20}
                bordered={false}
                columns={columns}
                noSearch
            />
            <ExportExcel
                baixarExcelController={async () =>
                    ExportarExcelRelatorioDeEnvioReguaController(props.req)
                }
                nomeArquivo={"Relatorio_Envio_Regua"}
            />
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
